import ApiService from '@/shared/api'
import GetCountEmployeesUserRequest from '@/shared/api/Main/dataSource/api/projects/performers/i-service/model/request/GetCountEmployeesUserRequest'
import { ResponseModel } from 'tir-pm-file-upload-manager'
import { CurrentUser } from 'tir-pm-user-core'

/**Сервис для отправки запросов */
export class MiddlewareAdapterService {
  /**API сервис */
  api = new ApiService()

  /**Получение количества человек в команде пользователя */
  GetCountEmployeesUser() {
    return new Promise<ResponseModel<number>>((resolve) => {
      const result = new ResponseModel<number>()
      this.api.Main.EmployeeService.getCountEmployeesUserAsync(
        new GetCountEmployeesUserRequest({ UserId: CurrentUser.Id })
      )
        .then((response) => {
          result.Value = response.Count
          return resolve(result)
        })
        .catch(() => {
          result.IsSuccess = false
          return resolve(result)
        })
    })
  }
}
